import { render, staticRenderFns } from "./AuditLogPage.vue?vue&type=template&id=00bc01e8&"
import script from "./AuditLogPage.vue?vue&type=script&lang=js&"
export * from "./AuditLogPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports